import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import styles from 'components/light-box-login/index.module.scss';
import lightBoxStyles from 'components/light-box-login/light-box-login.module.scss';
import { CSSTransition } from 'react-transition-group';
import { useLightBoxLoginContext, RESET_DIALOG } from 'components/light-box-login/use-light-box-login';
import DownloadStep from 'components/light-box-login/login-download-step';
import SmsStep from 'components/light-box-login/login-sms-step';
import LoginStep from 'components/light-box-login/login-step';
import SuccessStep from 'components/light-box-login/login-success-step';

const LightBoxLoginPortal = ({ onDismiss }) => {
  const rootEl = document.getElementById('root');
  const { state, dispatch } = useLightBoxLoginContext();

  const onClose = () => {
    onDismiss();
    setTimeout(() => {
      dispatch({ type: RESET_DIALOG });
    }, 300);
  };

  return ReactDOM.createPortal(
    <div className={styles['light-box']}>
      <div className={styles.mask} onClick={!state.cancelLightboxClose ? onClose : ''}>
        <div
          className={styles.dialog}
          onClick={e => {
            e.stopPropagation();
          }}
        >
          <div className={styles.close} onClick={!state.cancelLightboxClose ? onClose : ''} />
          <LoginStep />
          <SmsStep onDismiss={onDismiss} />
          <DownloadStep onDismiss={onDismiss} />
          <SuccessStep />
        </div>
      </div>
    </div>,
    rootEl
  );
};

const LightBoxLogin = ({ show, onDismiss }) => {
  useEffect(() => {
    if (show) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'inherit';
    }
  }, [show]);

  return (
    <CSSTransition
      in={show}
      unmountOnExit
      classNames={{
        enter: lightBoxStyles['light-box-login-enter'],
        enterActive: lightBoxStyles['light-box-login-enter-active'],
        exit: lightBoxStyles['light-box-login-exit'],
        exitActive: lightBoxStyles['light-box-login-exit-active'],
      }}
      timeout={300}
    >
      <LightBoxLoginPortal onDismiss={onDismiss} />
    </CSSTransition>
  );
};

export default LightBoxLogin;
